import { render, staticRenderFns } from "./MecanicoCard.vue?vue&type=template&id=4e04da82&scoped=true&"
import script from "./MecanicoCard.vue?vue&type=script&lang=js&"
export * from "./MecanicoCard.vue?vue&type=script&lang=js&"
import style0 from "./MecanicoCard.vue?vue&type=style&index=0&id=4e04da82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04da82",
  null
  
)

export default component.exports